import { render, staticRenderFns } from "./CommentRail.vue?vue&type=template&id=e2e1c13c"
import script from "./CommentRail.vue?vue&type=script&lang=js"
export * from "./CommentRail.vue?vue&type=script&lang=js"
import style0 from "./CommentRail.vue?vue&type=style&index=0&id=e2e1c13c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports